import { CombinedActionTypes } from '../../actionsFactory';
import Trip from 'model/ITrip';

type Booking = (Trip & { _type: 'booking' });

export interface State {
  [id: string]: {
    data?: any;
    isLoading: boolean;
    error?: any;
    bookingsInfo?: {
      total: number;
      bookings: string[];
    };
  };
}

export const initState: State = { };

const resolveRelation = (contact, relations) => ({
  ...contact,
  contact: relations.find(({ id, _type }) => _type === 'contact' && id === contact.id),
  firstActionableBooking: relations.find(({ id, _type }) => _type === 'booking' && id === contact.firstActionableBooking?.id)
});

export default (state: State, action: CombinedActionTypes): State => {
  switch(action.type) {
    case 'CONTACTS:FETCHING_SUCCESS':
    case 'ACTIONS_REQUIRED:FETCHING_SUCCESS':
      return action.payload.result.data.reduce<State>((accumulator, contact) => {
        accumulator[contact.id] = {
          ...state[contact.id],
          data: resolveRelation(contact, action.payload.result.relations),
          isLoading: false,
          error: null
        };
        return accumulator;
      }, state);
    case 'CONTACT:FETCHING_SUCCESS':
      return {
        ...state,
        [action.payload.result?.data?.[0]?.id]: {
          ...state[action.payload.result?.data?.[0]?.id],
          isLoading: false,
          data: resolveRelation(action.payload.result?.data?.[0], action.payload.result.relations),
          error: null
        }
      };
    case 'CONTACT:FETCHING':
      return {
        ...state,
        [action.payload.contactId]: {
          ...state[action.payload.contactId],
          isLoading: true,
          error: null
        }
      };
    case 'MESSAGES:MARK_AS_READ':
      return {
        ...state,
        [action.payload.contactId]: {
          ...state[action.payload.contactId],
          data: {
            ...state[action.payload.contactId].data,
            unread: 0,
          }
        }
      };
    case 'CONTACTS:FETCHING_BOOKINGS_SUCCESS':
      return action.payload.result.data.reduce<State>((accumulator, currentValue) => {
        accumulator[currentValue.contact] = {
          ...state[currentValue.contact],
          bookingsInfo: {
            total: currentValue.total,
            bookings: action.payload.result.relations
              .filter<Booking>((item): item is Booking => [currentValue.firstActionable, currentValue.firstUpcoming, currentValue.lastModified].includes(item.id) && item._type === 'booking')
              .map(({ id }) => id)
          }
        };
        return accumulator;
      }, state);
    default:
      return state;
  }
};
